import { Component, input } from '@angular/core';

@Component({
  selector: 'IntegrationConnection',
  template: `
    <div
      class="
        w-full h-full rounded-full center
        {{ active() ? 'bg-blue-100 text-blue-500' : 'bg-gray-100 text-gray-400' }}
      "
    >
      <svg
        class="{{ svgClass() }} flex-none"
        viewBox="0 0 50 30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 3 5 15l12 12M5 15h40M33 3l12 12-12 12"
          stroke="currentColor"
          stroke-width="6"
          fill="none"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  `,
})
export class IntegrationConnection {
  readonly active = input(true);
  readonly svgClass = input('');
}
